import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Typography } from '@mui/material'

export interface IncompleteStatementDialogProps {
  onClose: () => void
  onLeave: () => void
  onSave: () => void
  isSaveEnabled: boolean
}

/**
 * This component provides a modal dialog, that is shown if the user wants to close
 * the statements wizard without completing it.
 * @param onClose  provide closing function by removing it from redux list
 * @param onLeave  closing the warning and the statement dialog too, without saving anything
 * @param onSave  saving the installation statement data
 * @returns a Dialog with custom content
 */
const IncompleteStatementDialog: React.FC<IncompleteStatementDialogProps> = ({ onClose, onLeave, onSave, isSaveEnabled }) => {
  const { t } = useCustomTranslation()

  const modalActions = {
    primary: {
      name: t('common.save'),
      onClick: () => {
        onSave()
        onClose()
      },
      disabled: !isSaveEnabled,
    },
    secondary: {
      name: t('common.dialogs.unsavedChanges.controls.cancel'),
      onClick: () => {
        onClose()
      },
    },
  }

  return (
    <Dialog
      title={t('common.dialogs.unsavedChanges.title')}
      onClose={onClose}
      actions={modalActions}
      additionalActionsLeft={
        <Button
          onClick={() => {
            onLeave()
          }}
          color="inherit"
          variant={'outlined'}
          sx={{ width: '100%' }}
        >
          {t('common.dialogs.unsavedChanges.controls.continue')}
        </Button>
      }
      maxWidth="sm"
    >
      <Box pt={4}>
        <Typography variant={'body1'}>{t('common.dialogs.unsavedChanges.message')}</Typography>
      </Box>
    </Dialog>
  )
}

export default IncompleteStatementDialog
